module.exports = "<corporate-page></corporate-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appCustomers/corporate.html
// module id = 1310
// module chunks = 0